import { render, staticRenderFns } from "./MultiFileSelector.vue?vue&type=template&id=7ff864e3&scoped=true&"
import script from "./MultiFileSelector.vue?vue&type=script&lang=js&"
export * from "./MultiFileSelector.vue?vue&type=script&lang=js&"
import style0 from "./MultiFileSelector.vue?vue&type=style&index=0&id=7ff864e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff864e3",
  null
  
)

export default component.exports